import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {updateAccountAsync} from "@/app/(pages)/account/accountAPI";
import {RootState} from "@/app/store";
import {API_ACCOUNT} from "@/app/_api/types/account";

export interface AccountInfoState {
    info: {
        userVipExp: number,
        userVipName: string,
        userNextVipExp: number,
        vipConfigList: API_ACCOUNT.VipConfigListResponse,
    },
    responseStatus: 'finish' | 'loading' | 'failed'
}

const initialState: AccountInfoState = {
    info: {
        userVipExp: 0,
        userVipName: '',
        userNextVipExp: 0,
        vipConfigList: {
            vipLevels: [],
            vipBenefits: []
        },
    },
    responseStatus: 'finish',
}

export const AccountInfoSlice = createSlice({
    name: 'accountInfo',
    initialState,
    reducers: {
        updateAccountInfo: (state, action) => {
            state.info = action.payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(updateAccountAsync.pending, state => {
                state.responseStatus = 'loading'
            })
            .addCase(updateAccountAsync.fulfilled, (state, action) => {
                state.responseStatus = 'finish'
                console.log(action.payload)
                state.info.userVipExp = action.payload?.userVipExp || 0;
                state.info.userVipName = action.payload?.userVipName || '';
                state.info.userNextVipExp = action.payload?.userNextVipExp || 0;
                state.info.vipConfigList = action.payload?.vipConfigList || {
                    vipLevels: [],
                    vipBenefits: []
                };
            })
            .addCase(updateAccountAsync.rejected, state => {
                state.responseStatus = 'failed'
            })
    }
})



export const { updateAccountInfo } = AccountInfoSlice.actions;

export const selectAccountInfo = (state: RootState) => state.accountInfo;

export default AccountInfoSlice.reducer;
